import { useLiveUserRole } from "./useLiveUserRole";
import { useAccessRight } from "./useAccessRight";
import {
  ACTION_ACCESS_HIDDEN,
  ACTION_ACCESS_ACCESSIBLE,
} from "../data/actionRegistry";

const toAccessRight = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : ACTION_ACCESS_HIDDEN;
};

/**
 * Per-button action permissions from userRole.actionLinks.
 * Uses the live role document so role-editor Disable applies without re-login.
 */
export const useActionRight = () => {
  const userRole = useLiveUserRole();
  const [, rawPageAccessRight] = useAccessRight();
  const pageAccessRight = toAccessRight(rawPageAccessRight);

  const getActionRight = (entity, action) => {
    const entry = userRole?.actionLinks?.find(
      (a) => a.entity === entity && a.action === action
    );
    return toAccessRight(entry?.accessRight ?? ACTION_ACCESS_HIDDEN);
  };

  const isActionVisible = (entity, action) => {
    if (pageAccessRight === 0) return false;
    return getActionRight(entity, action) !== ACTION_ACCESS_HIDDEN;
  };

  /**
   * @param {string} entity
   * @param {string} action
   * @param {{ requireFullAccess?: boolean }} options
   */
  const isActionEnabled = (entity, action, options = {}) => {
    const { requireFullAccess = true } = options;

    if (!isActionVisible(entity, action)) return false;
    if (pageAccessRight === 1) return false;
    if (getActionRight(entity, action) !== ACTION_ACCESS_ACCESSIBLE) {
      return false;
    }
    if (requireFullAccess && pageAccessRight !== 15) return false;
    return true;
  };

  /** @deprecated use isActionEnabled */
  const canAccessAction = isActionEnabled;

  return {
    getActionRight,
    isActionVisible,
    isActionEnabled,
    canAccessAction,
    pageAccessRight,
  };
};
